import Joi from "joi-browser";
import _, { isEmpty } from "lodash";
import moment from "moment";
import { createRef } from "react";
import { connect } from "react-redux";
import { withRouter, Link } from "react-router-dom";
import { toast } from "react-toastify";
import { updateTeamPlayChallenge, updateTeamPlayChallengeReceived } from "store/telegram";

//  Images
import closeIcon from "include/images/close-icon.svg";
import filterIcon from "include/images/filter-icon.svg";
import emptyIcon from "include/images/nrf.svg";
import carrentIcon from "include/images/carrent-icon.svg";
import loadingIcon from "include/images/loader-grey.svg";
import plusIcon from "include/images/plus.svg";

//  Components
import AlertError from "common/alert/alertError";
import AlertSuccess from "common/alert/alertSuccess";
import Form from "common/form/form";
import NextButton from "common/form/submitButton";
import Header from "common/header";
import Loader from "common/loader";
import SideBar from "common/sidebar";
import { PLAYER_VS_PLAYER_PRIZE_TYPES, TELEGRAM_PLAYER_VS_PLAYER_PRIZE_TYPES } from "utils/constants";
import { Dropdown } from "react-bootstrap";
import AlertModal from "common/alert/alertModal";
import {
  deletePvPContest,
  deletePvpReceived,
  getPvP,
  loadPvPContests,
  updatePvPContest,
  updatePvpReceived,
} from "store/pvp";
import AddPvpContest from "./addPvpContest";
import SelectSearch from "common/form/selectSearch";

class PvpListing extends Form {
  ref = createRef(null);
  refCsv = createRef(null);
  state = {
    data: {
      keyword: "",
      prizeType: null,
      entryFeeType: null,
    },
    id: "",
    loadingOptions: false,
    loadingMain: false,
    loadingDelete: false,
    loading: false,
    showDeleteModal: false,
    showAddModal: false,
    cancelId: "",
    editData: null,
    showHistory: false,
    objectId: "",
    object: null,
    page: 1,
    statusInd: null,
    loadingStatus: false,
    showLeaderboard: false,
    showWinners: false,
    challenge: null,
    winnersCSV: [],
    loadingCsv: false,
    sweeps: null,
    errors: {},
    appliedFilters: {},
  };
  componentDidUpdate = (prevProps, prevState) => {
    if (!this.props.getPvP.loading && this.props.getPvP.loading !== prevProps.getPvP.loading)
      this.ref.current.complete();

    if (this.props.getPvP.loading && this.props.getPvP.loading !== prevProps.getPvP.loading)
      this.ref.current.continuousStart();

    if (this.state.showAddModal !== prevState.showAddModal && !this.state.showAddModal) {
      setTimeout(() => {
        this.setState({ editData: null });
      }, 500);
    }
    const params = new URLSearchParams(this.props.location.search);
    const status = params.get("status");
    const prevParams = new URLSearchParams(prevProps.location.search);
    const prevStatus = prevParams.get("status");

    if (status !== prevStatus) this.getPvpContests();
  };
  componentDidMount = () => {
    this.getPvpContests();
  };
  getPvpContests = () => {
    const searchParams = new URLSearchParams(this.props.location.search);
    const status = searchParams.get("status");
    const page = this.state.page;
    this.setState({ loadingMain: true });
    this.props.loadPvPContests({ page, status }, (res) => {
      this.setState({
        loadingMain: false,
      });
    });
  };

  toggleAddModal = (e) => {
    if (e) e.preventDefault();
    this.setState({ showAddModal: !this.state.showAddModal });
  };

  onChange = (e) => {
    const { name, value } = e.target;
    this.setState({
      data: { ...this.state.data, [name]: value },
    });
  };

  onchangeSelect = (e) => {
    console.log(e.currentTarget.value);
    const data = { ...this.state.data };
    data[e.name] = e.currentTarget;
    this.setState({ data });
  };
  handleCancel = (e) => {
    this.setState({ loadingDelete: true });
    this.props.deletePvPContest(this.state.cancelId, (challengeRes) => {
      if (challengeRes.status === 200) {
        toast(<AlertSuccess message="Deleted!" />, {
          containerId: 1,
        });
        this.props.deletePvpReceived(this.state.cancelId);
        this.cancelModalToggle();
        this.setState({ loadingDelete: false });
      } else {
        toast(<AlertError message={challengeRes.data && challengeRes.data.message} />, {
          containerId: 1,
        });
        this.cancelModalToggle();
        this.setState({ loadingDelete: false });
      }
    });
  };
  schema = {
    keyword: Joi.string().allow(""),
    status: Joi.object().allow(null),
  };
  changeStatus = (e) => {
    this.setState({ loadingStatus: true });
    const payLoad = { isActive: this.state.statusInd };
    delete payLoad._id;
    this.props.updatePvPContest(this.state.statusChangeId, payLoad, (statusRes) => {
      this.setState({
        loadingStatus: false,
      });
      if (statusRes.status === 200) {
        this.props.updatePvpReceived(statusRes.data.data);
      } else {
        toast(<AlertError message={statusRes.data && statusRes.data.message} />, {
          containerId: 1,
        });
      }
    });
  };
  cancelModalToggle = (e) => {
    if (e) e.preventDefault();
    this.setState({ showDeleteModal: !this.state.showDeleteModal });
  };
  searchFilters = (e) => {
    if (e) e.preventDefault();

    this.setState({ loadingFilters: true });
    var params = _.pickBy(this.state.data, function (value, key) {
      return !_.isEmpty(value);
    });
    params.page = this.state.page;
    if (this.state.data.prizeType?.value) {
      params.prizeType = this.state.data.prizeType.value;
    }
    if (this.state.data.entryFeeType?.value) {
      params.entryFeeType = this.state.data.entryFeeType.value;
    }
    this.props.loadPvPContests(params, (challengeRes) => {
      this.setState({
        loadingFilters: false,
      });
      if (challengeRes?.status === 200) {
        const data = { ...this.state.data };
        const appliedFilters = {};
        Object.keys(this.state.data).forEach((key) => {
          if (!_.isEmpty(data[key])) {
            appliedFilters[key] = data[key];
          }
        });
        this.setState({ appliedFilters });
      }
    });
  };
  resetFilters = (e) => {
    e.preventDefault();
    this.setState(
      {
        data: {
          keyword: "",
          prizeType: null,
          entryFeeType: null,
        },
      },
      () => this.searchFilters(),
    );
  };
  removeFilter = (type) => {
    const data = this.state.data;
    data[type] = "";
    this.setState({ data }, this.searchFilters);
  };
  getOrdinalSuffix(number) {
    const remainder100 = number % 100;
    const remainder10 = number % 10;

    // Handle special cases for 11, 12, and 13
    if (remainder100 >= 11 && remainder100 <= 13) {
      return `${number}th`;
    }

    // Handle general cases based on last digit
    switch (remainder10) {
      case 1:
        return `${number}st`;
      case 2:
        return `${number}nd`;
      case 3:
        return `${number}rd`;
      default:
        return `${number}th`;
    }
  }

  render() {
    const { pvpList, totalCount } = this.props.getPvP;
   
    return (
      <>
        <Header history={this.props.history} />
        <Loader loaderRef={this.ref} />
        <div className="page-wrapper add-dev-server-wrapper">
          <SideBar page="telegram-mini-app-player-vs-player-contest" />
          <div className="main-content-wrapper position-relative">
            <div className="mcw-header d-flex align-items-center">
              <h1>Player vs Player Contest {totalCount > 0 && `(${totalCount})`}</h1>
              <div className="filter-menu-box d-flex align-items-center ms-auto">
                <div className="fmb-box">
                  <a
                    href="#!"
                    className="filter-link-box"
                    onClick={(e) => {
                      e.preventDefault();
                      this.setState({
                        showFilters: !this.state.showFilters,
                      });
                    }}
                  >
                    <img src={filterIcon} /> <span>Filters</span>
                  </a>
                </div>
                <div className="fmb-box">
                  <Link
                    to="#"
                    onClick={this.toggleAddModal}
                    className="btn btn-default btn-sm d-flex justify-content-center"
                  >
                    <img src={plusIcon} alt="" /> Add a Player vs Player Contest
                  </Link>
                </div>
              </div>
            </div>
            <div className="fwc-wrapper">
              {this.state.showFilters && (
                <div className="fwc-head ">
                  <div className="fwc-inner">
                    <ul className="filter-mode-list question-filter-mode-list d-flex flex-wrap align-items-center">
                      <li className="flex-fill">
                        <div className="fml-box">{this.renderInput("keyword", "Contest Name")}</div>
                      </li>{" "}
                      <li className="flex-fill">
                        <div className="fml-box">
                          <div className="d-flex align-items-center justify-content-between">
                            <label className="form-label">Entry Fee Type</label>
                          </div>
                          <SelectSearch
                            name="entryFeeType"
                            options={PLAYER_VS_PLAYER_PRIZE_TYPES}
                            label="Entry Fee Type"
                            value={this.state.data.entryFeeType}
                            error={this.state.errors.entryFeeType}
                            onChange={(e) => this.onchangeSelect(e)}
                          />
                        </div>
                      </li>{" "}
                      <li className="flex-fill">
                        <div className="fml-box">
                          <div className="d-flex align-items-center justify-content-between">
                            <label className="form-label">Prize Type</label>
                          </div>
                          <SelectSearch
                            name="prizeType"
                            options={PLAYER_VS_PLAYER_PRIZE_TYPES}
                            label="Prize Type"
                            value={this.state.data.prizeType}
                            error={this.state.errors.prizeType}
                            onChange={(e) => this.onchangeSelect(e)}
                          />
                        </div>
                      </li>
                    </ul>
                    <div className="fwc-btn d-flex align-items-center justify-content-end">
                      <NextButton
                        handleSubmit={this.resetFilters}
                        classData="btn-text pointer"
                        label="Reset"
                        loading={this.state.loadingReset}
                      />
                      <NextButton
                        handleSubmit={() => {
                          this.setState(
                            {
                              page: 1,
                            },
                            () => this.searchFilters(),
                          );
                        }}
                        classData="btn btn-primary btn-sm"
                        label="Search"
                        loading={this.state.loadingFilters}
                      />
                    </div>
                  </div>{" "}
                  {!isEmpty(this.state.appliedFilters) && (
                    <div className="filter-tag-container d-flex align-items-center ">
                      <div className="fwc-left">
                        <div className="filter-tag-list">
                          <p>filter applied :</p>

                          {Object.keys(this.state.appliedFilters).map((key) => {
                            const filterValue = this.state.appliedFilters[key];

                            // Convert value for display
                            const displayValue =
                              typeof filterValue === "object" ? filterValue?.name || filterValue?.value : filterValue;

                            return (
                              <div className="filter-tag-item" key={key}>
                                <span className="camelCase">
                                  {key === "keyword"
                                    ? "Contest Name"
                                    : key === "entryFeeType"
                                    ? "Entry Fee Type"
                                    : key === "prizeType"
                                    ? "Prize Type"
                                    : key === "playerOneUserName"
                                    ? "Player One User Name"
                                    : key === "playerTwoUserName"
                                    ? "Player Two User Name"
                                    : key}
                                </span>
                                : {displayValue}
                                <a
                                  href="#!"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    this.setState(
                                      {
                                        data: {
                                          ...this.state.data,
                                          [key]: key === "keyword" ? "" : null,
                                        },
                                        page: 1,
                                      },
                                      this.searchFilters,
                                    );
                                  }}
                                >
                                  <img src={closeIcon} alt="" />
                                </a>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              )}{" "}
              <div className="fwc-body">
                {!this.state.loadingMain && (
                  <div className="table-responsive">
                    {pvpList?.length === 0 ? (
                      <div className="fwc-body">
                        <div className="no-record-found-container">
                          <div className="nfr-box">
                            <img src={emptyIcon} alt="No Record Found" />
                            <div className="nrf-text">
                              <h5>No Records Found!</h5>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <table className="table large-table">
                        <thead>
                          <tr>
                            <th style={{ textAlign: "center", width: 40 }}>Actions</th>
                            <th>Title</th>
                            <th>Game</th>
                            <th>Image</th>
                            <th>Start Date</th>
                            <th>Entry Fee</th>
                            <th>Prize</th>
                            <th style={{ width: 80 }}>Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          {pvpList?.map((challenge, i) => (
                            <tr>
                              <td>
                                <Dropdown className=" custom-dropdown">
                                  <Dropdown.Toggle
                                    id="tdDropdownOne"
                                    className={`custom-dropdown-toggle`}
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                  >
                                    <img src={carrentIcon} alt="" />
                                  </Dropdown.Toggle>
                                  <Dropdown.Menu className={`dropdown-menu-start `} aria-labelledby="tdDropdownOne">
                                    <Dropdown.Item
                                      className="dropdown-item"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        this.setState({ editData: challenge }, () => {
                                          this.toggleAddModal();
                                        });
                                      }}
                                    >
                                      Edit
                                    </Dropdown.Item>
                                    <Dropdown.Item
                                      className="dropdown-item delete"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        this.setState({ cancelId: challenge?._id }, () => {
                                          this.cancelModalToggle();
                                        });
                                      }}
                                    >
                                      Delete
                                    </Dropdown.Item>
                                  </Dropdown.Menu>
                                </Dropdown>
                              </td>
                              <td>
                                <Link
                                  to="#!"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    this.setState({ editData: challenge }, () => {
                                      this.toggleAddModal();
                                    });
                                  }}
                                  className={`td-text-box d-flex align-items-center ${
                                    challenge?.status !== "scheduled" && "pointer-none"
                                  }`}
                                >
                                  {challenge?.name}
                                </Link>
                              </td>
                              <td>
                                <Link
                                  to="#!"
                                  className={`td-text-box d-flex align-items-center ${
                                    challenge?.status !== "scheduled" && "pointer-none"
                                  }`}
                                >
                                  {challenge?.bgGame?.name}
                                </Link>
                              </td>
                              <td>
                                <div className="td-text-box d-flex align-items-center">
                                  <div className="td-img margin-right-2 pointer">
                                    {challenge?.bgGame && (
                                      <img
                                        src={process.env.REACT_APP_CDN + challenge?.bgGame?.telegramAppImage}
                                        alt=""
                                      />
                                    )}
                                  </div>
                                </div>
                              </td>
                              <td>
                                <div class="small-text">
                                  {challenge?.createdAt && moment(challenge?.createdAt).format("MM/DD/YYYY")}
                                  <br />{" "}
                                  <small>
                                    {challenge?.createdAt && moment(challenge?.createdAt).format("hh:mm a")}
                                  </small>
                                </div>
                              </td>
                              <td>
                                {challenge?.entryFee} {TELEGRAM_PLAYER_VS_PLAYER_PRIZE_TYPES[challenge?.entryFeeType]}
                              </td>
                              <td>
                                {challenge?.prize} {TELEGRAM_PLAYER_VS_PLAYER_PRIZE_TYPES[challenge?.prizeType]}
                              </td>
                              <td className="ust-tag">
                                <Dropdown className="custom-dropdown">
                                  <Dropdown.Toggle
                                    id="tdDropdownOne"
                                    className="custom-dropdown-toggle"
                                    disabled={this.state.loadingStatus}
                                  >
                                    <span
                                      className={`w-100 text-center d-block camelCase ${
                                        challenge.isActive ? "active" : "inactive"
                                      } ${this.state.loadingStatus && "pointer-none"}`}
                                    >
                                      {this.state.loadingStatus && this.state.statusChangeId === challenge._id ? (
                                        <img
                                          src={loadingIcon}
                                          alt="loading..."
                                          style={{ width: 20 }}
                                          className="fa-spin"
                                        />
                                      ) : challenge.isActive ? (
                                        "Active"
                                      ) : (
                                        "Paused"
                                      )}
                                    </span>
                                  </Dropdown.Toggle>

                                  <Dropdown.Menu className="dropdown-menu-start" aria-labelledby="tdDropdownOne">
                                    <>
                                      <Dropdown.Item
                                        onClick={() => {
                                          this.setState(
                                            {
                                              statusChangeId: challenge._id,
                                              sweeps: challenge,
                                              statusInd: challenge.isActive ? false : true, // toggle
                                              loadingStatus: true,
                                            },
                                            this.changeStatus,
                                          );
                                        }}
                                      >
                                        {challenge.isActive ? "Pause" : "Active"}
                                      </Dropdown.Item>
                                    </>
                                  </Dropdown.Menu>
                                </Dropdown>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    )}
                  </div>
                )}
                {!this.state.loadingMain &&
                  !(this.state.page === 1 && pvpList?.length === 0) &&
                  !(pvpList?.length < 20 && this.state.page === 1) && (
                    <div className="page-pagination">
                      <ul className="pagination  justify-content-end">
                        <li className="page-item">
                          <a
                            class={`page-link ${this.state.page === 1 && "disabled"}`}
                            href="#!"
                            aria-label="Previous"
                            onClick={(e) => {
                              e.preventDefault();
                              if (this.state.page > 1) {
                                this.setState({ page: this.state.page - 1 }, () => this.searchFilters());
                              }
                            }}
                          >
                            <svg
                              width="8"
                              height="14"
                              viewBox="0 0 8 14"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path d="M7 13L1 7L7 1" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                          </a>
                        </li>
                        <li className="page-item active">
                          <a
                            className="page-link"
                            href="#!"
                            onClick={(e) => {
                              e.preventDefault();
                            }}
                          >
                            {this.state.page}
                          </a>
                        </li>
                        {pvpList?.length >= 20 && (
                          <li className="page-item">
                            <a
                              className="page-link"
                              href="#!"
                              onClick={(e) => {
                                e.preventDefault();
                                this.setState({ page: this.state.page + 1 }, () => this.searchFilters());
                              }}
                            >
                              {this.state.page + 1}
                            </a>
                          </li>
                        )}
                        <li className="page-item">
                          <a
                            class={`page-link ${pvpList?.length < 20 && "disabled"}`}
                            href="#!"
                            aria-label="Next"
                            onClick={(e) => {
                              e.preventDefault();
                              this.setState({ page: this.state.page + 1 }, () => this.searchFilters());
                            }}
                          >
                            <svg
                              width="8"
                              height="14"
                              viewBox="0 0 8 14"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path d="M1 13L7 7L1 1" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                          </a>
                        </li>
                      </ul>
                    </div>
                  )}
              </div>
            </div>
          </div>
        </div>
        <AddPvpContest
          showModal={this.state.showAddModal}
          toggleModal={this.toggleAddModal}
          edit={this.state.editData}
        />
        <AlertModal
          alertModalToggle={this.cancelModalToggle}
          alertModalShow={this.state.showDeleteModal}
          alertType="Yes"
          title="Alert"
          description="Are you sure you want to delete this Player vs Player Contest?"
          onPress={this.handleCancel}
          loading={this.state.loadingDelete}
        />
        {this.state.showAddModal && <div className="modal-backdrop show fade" onClick={this.toggleAddModal}></div>}
      </>
    );
  }
}
const mapDispatchToProps = (dispatch) => ({
  loadPvPContests: (params, callback) => dispatch(loadPvPContests(params, callback)),
  updatePvpReceived: (payLoad) => dispatch(updatePvpReceived(payLoad)),
  updatePvPContest: (id, data, callback) => dispatch(updatePvPContest(id, data, callback)),
  deletePvPContest: (id, callback) => dispatch(deletePvPContest(id, callback)),
  deletePvpReceived: (payLoad) => dispatch(deletePvpReceived(payLoad)),
});
const mapStateToProps = (state) => ({
  getPvP: getPvP(state),
});
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PvpListing));
